<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>设备类型：</label>
                        <el-select v-model="search_Obj.f_relation_type" clearable placeholder="请选择" @keyup.enter.native="doSearch" style="width: 220px">
                            <el-option v-for="item in enuObj('relation_type')" :key="'relation_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>灌浆记录仪编号：</label>
                        <el-input v-model="search_Obj.f_work_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>数据采集器编号：</label>
                        <el-input v-model="search_Obj.f_check_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>非接触设备编号：</label>
                        <el-input v-model="search_Obj.f_extarct_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="relation_type" label="关联类型" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.relation_type, "relation_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="work_code" label="灌浆记录仪编号" sortable="custom"></el-table-column>
                        <el-table-column prop="check_code" label="数据采集器编号" sortable="custom"></el-table-column>
                        <el-table-column prop="extarct_code" label="非接触设备编号" sortable="custom"></el-table-column>
                        <el-table-column prop="channel_no" label="通道号" sortable="custom"></el-table-column>
                        <el-table-column prop="time_difference" label="时间差" sortable="custom"></el-table-column>
                        <el-table-column prop="start_time" label="开始时间" sortable="custom"></el-table-column>
                        <el-table-column prop="end_time" label="结束时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看设备关联记录"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceRelationTimeLogList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '设备关联记录',
            menu_id: 3390,
            list_url: "/api/admin/devicerelationtimelog/list",
            search_Obj: {
                f_relation_type: '',
                f_check_code: '',
                f_work_code: '',
                f_extarct_code: '',
            },
            del_Obj:{
                url:'/api/admin/devicerelationtimelog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['relation_type'],
        };
    },
    methods: {}
};
</script>